import React from 'react';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { CSSTransition } from 'react-transition-group';

import { RootState } from '../store/store';
import css from './global-progress-bar.module.css';

export default function GlobalProgressBar() {
  const { loading } = useSelector((state: RootState) => ({
    loading: state.global.loading,
  }));
  const [loadingTotal, setLoadingTotal] = useState(loading);
  const [loadingDone, setLoadingDone] = useState(0.0);
  const ref = React.useRef(null);

  useEffect(() => {
    if (loading > 0 && loadingDone === 1) {
      // restart
      setLoadingDone(0);
      setLoadingTotal(loading);
    } else if (loading === 0) {
      // finish
      setLoadingDone(1);
    } else if (loading > loadingTotal) {
      // new goal
      setLoadingTotal(loading);
    } else {
      // progress
      setLoadingDone(
        Math.max(loadingDone, (loadingTotal - loading) / loadingTotal)
      );
    }
  }, [loading, loadingDone, loadingTotal]);

  return (
    <CSSTransition
      nodeRef={ref}
      in={loadingDone !== 1}
      timeout={500}
      classNames={{
        enter: css['enter'],
        enterActive: css['enter-active'],
        enterDone: css['enter-done'],
        exit: css['exit'],
        exitActive: css['exit-active'],
        exitDone: css['exit-done'],
      }}
    >
      <div ref={ref} className={css['global-progress-bar']}>
        <div
          className={css['done']}
          style={{ width: (loadingDone * 100).toString().concat('%') }}
        ></div>
      </div>
    </CSSTransition>
  );
}
